import { LinearGradient } from 'expo-linear-gradient'
import React, { useEffect, memo } from 'react'
import { View, Text, StyleSheet, TouchableOpacity } from 'react-native'
import theme from '../../../../theme'
import styles from '../../stores/StoreDetailStyles'
import { Image } from 'expo-image'
import * as Progress from 'react-native-progress'
import { StoreKPIIndicatorTheme } from '../../../../themeConstants'

export const StoreKPIIndicators = React.memo(({ item, index }: any) => {
    const getGradientColors = (index) => {
        const gradientIndex = index % 5
        const isInverted = Math.floor(index / 5) % 2 === 1
        const gradientStartKey = `linearGradientStart0${gradientIndex}`
        const gradientEndKey = `linearGradientEnd0${gradientIndex}`

        // console.log(`Index: ${index}, Gradient Index: ${gradientIndex}, Is Inverted: ${isInverted}`)
        // console.log(`Start Color Key: ${gradientStartKey}, End Color Key: ${gradientEndKey}`)
        // console.log(`Start Color: ${theme.colors[gradientStartKey]}, End Color: ${theme.colors[gradientEndKey]}`)

        if (isInverted) {
            return [theme.colors[gradientEndKey], theme.colors[gradientStartKey]]
        } else {
            return [theme.colors[gradientStartKey], theme.colors[gradientEndKey]]
        }
    }

    const gradientColors = (getGradientColors(index) as unknown) as readonly [string, string]

    const renderItem = (type: string, value: number = 0) => {
        switch (type) {
            case 'percentage':
                const fix = value === 100 ? 0 : 1
                const progressText = `${value.toFixed(fix)}%`
                return (
                    <Progress.Circle
                        size={75}
                        progress={value / 100}
                        showsText={true}
                        formatText={(progress) => progressText}
                        textStyle={{
                            fontSize: 16,
                            fontWeight: 'bold',
                        }}
                        thickness={8}
                        color={StoreKPIIndicatorTheme.progressFilledColor}
                        unfilledColor={StoreKPIIndicatorTheme.progressUnfilledCollor}
                        borderWidth={0}
                        strokeCap='round'
                    />
                )
            default: //"number"
                return (
                    <View
                        style={{
                            width: 85,
                            height: 75,
                            alignItems: 'center',
                            justifyContent: 'center',
                        }}
                    >
                        <Text style={{ fontSize: 50, color: 'white', fontWeight: '700' }}>{value}</Text>
                    </View>
                )
        }
    }

    return (
        <View style={[styles.containerItemsIndicators]}>
            <TouchableOpacity activeOpacity={1}>
                <LinearGradient
                    style={[styles.containerIndicator, { height: 145, justifyContent: 'space-between' }]}
                    colors={gradientColors}
                    start={{ x: 0, y: 0 }}
                    end={{ x: 1, y: 0.5 }}
                >
                    <Text
                        style={[{ fontSize: 11, fontWeight: 'bold', textTransform: 'uppercase', textAlign: 'center', color: 'white', marginTop: 5 }]}
                        numberOfLines={1}
                    >
                        {item.kpi}
                    </Text>
                    <View style={[styles.containerProgress, { height: undefined }]}>{renderItem(item.type, item.value)}</View>
                    <Text
                        style={[{ fontSize: 11, fontWeight: 'bold', textTransform: 'uppercase', textAlign: 'center', color: 'white' }]}
                        numberOfLines={1}
                    >
                        {item.criticalMomentCode}
                    </Text>
                </LinearGradient>
            </TouchableOpacity>
        </View>
    )
})
